<template>
  <div v-if="layoutType === 'transport' && cityCount">
    <!-- <div class="layout-container">
      <div class="custom-skeleton p-4" style="width: 300px" v-if="isLoadingArravalsData">
        <ul class="m-0 p-0">
          <li class="mb-3">
            <div class="flex">
              <Skeleton shape="circle" size="4rem" class="mr-2"></Skeleton>
              <div style="flex: 1">
                <Skeleton width="100%" class="mb-2"></Skeleton>
                <Skeleton width="75%"></Skeleton>
              </div>
            </div>
          </li>
          <li class="mb-3">
            <div class="flex">
              <Skeleton shape="circle" size="4rem" class="mr-2"></Skeleton>
              <div style="flex: 1">
                <Skeleton width="100%" class="mb-2"></Skeleton>
                <Skeleton width="75%"></Skeleton>
              </div>
            </div>
          </li>
          <li class="mb-3">
            <div class="flex">
              <Skeleton shape="circle" size="4rem" class="mr-2"></Skeleton>
              <div style="flex: 1">
                <Skeleton width="100%" class="mb-2"></Skeleton>
                <Skeleton width="75%"></Skeleton>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="layout transport" v-if="!isLoadingArravalsData">
        <span class="interactive-map-layout-title">Modais</span>
        <span class="interactive-map-layout-subtitle aero">AEROVIÁRIO</span>
        <span class="interactive-map-layout-modal">Aeroporto internacional de Foz do Iguaçu</span>
        <div class="interactive-map-layout-content-icons">
          <span class="interactive-map-layout-content-icons-ticket"
            ><i class="fa-solid fa-ticket"></i>15.000</span
          >
          <span class="interactive-map-layout-content-icons-arrow-up"
            ><i class="fa-solid fa-arrow-up arrow-up"></i>5.000</span
          >
          <span class="interactive-map-layout-content-icons-arrow-down"
            ><i class="fa-solid fa-arrow-down arrow-down"></i>3.000</span
          >
        </div>
      </div>

      <div class="layout transport" style="margin-top: 20px" v-if="!isLoadingArravalsData">
        <span class="interactive-map-layout-subtitle rodo">RODOVIÁRIO</span>
        <span class="interactive-map-layout-modal">Rodoviária internacional de Foz do Iguaçu</span>
        <div class="interactive-map-layout-content-icons">
          <span class="interactive-map-layout-content-icons-ticket"
            ><i class="fa-solid fa-ticket"></i>15.000</span
          >
          <span class="interactive-map-layout-content-icons-arrow-up"
            ><i class="fa-solid fa-arrow-up arrow-up"></i>5.000</span
          >
          <span class="interactive-map-layout-content-icons-arrow-down"
            ><i class="fa-solid fa-arrow-down arrow-down"></i>3.000</span
          >
        </div>
      </div>
    </div> -->
    <div
      class="layout-container"
      style="height: 100%; max-height: 550px; overflow-y: auto; margin-top: 20px"
    >
      <div class="custom-skeleton p-4" style="width: 300px" v-if="isLoadingArravalsData">
        <ul class="m-0 p-0">
          <li class="mb-3">
            <div class="flex">
              <Skeleton shape="circle" size="4rem" class="mr-2"></Skeleton>
              <div style="flex: 1">
                <Skeleton width="100%" class="mb-2"></Skeleton>
                <Skeleton width="75%"></Skeleton>
              </div>
            </div>
          </li>
          <li class="mb-3">
            <div class="flex">
              <Skeleton shape="circle" size="4rem" class="mr-2"></Skeleton>
              <div style="flex: 1">
                <Skeleton width="100%" class="mb-2"></Skeleton>
                <Skeleton width="75%"></Skeleton>
              </div>
            </div>
          </li>
          <li class="mb-3">
            <div class="flex">
              <Skeleton shape="circle" size="4rem" class="mr-2"></Skeleton>
              <div style="flex: 1">
                <Skeleton width="100%" class="mb-2"></Skeleton>
                <Skeleton width="75%"></Skeleton>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="table-container" v-if="!isLoadingArravalsData">
        <h2 style="margin-bottom: 15px" v-if="!predictArrivalsDepartures">Origem</h2>
        <h2 style="margin-bottom: 15px" v-if="predictArrivalsDepartures">Previsão de Origem</h2>
        <CustomSkeleton v-if="isLoadingPredictionInteractiveMap" type="card" />
        <table v-if="!isLoadingPredictionInteractiveMap" class="table">
          <tr v-for="(data, index) in cityCount" :key="index">
            <td class="icon-column">
              <i class="fa fa-circle" :style="{ color: getColor(index) }" aria-hidden="true"></i>
            </td>
            <td class="city-column">{{ data.state }}</td>
            <td class="value-column">{{ data.count }}</td>
            <td class="percentage-column">{{ data.percentage }}%</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import Skeleton from 'primevue/skeleton'
import { mapState } from 'pinia'
import CustomSkeleton from '@/Shared/CustomSkeleton'
import { useCustomHeader } from '../../../../../../../stores/customHeader'
import { useInteractiveMap } from '../../../../../../../stores/interactiveMap'
export default {
  name: 'Transport',
  components: {
    Skeleton,
    CustomSkeleton,
  },
  props: {
    layoutType: String,
    isLoadingArravalsData: Boolean,
  },
  computed: {
    ...mapState(useCustomHeader, ['isLoadingPredictionInteractiveMap']),
    ...mapState(useInteractiveMap, ['cityCount']),
    ...mapState(useInteractiveMap, ['predictArrivalsDepartures']),
  },
  methods: {
    getColor(index) {
      const colors = ['#00A86B', '#007FFF', '#DAA520', '#6A5ACD', '#9370DB']
      return colors[index % colors.length]
    },
  },
}
</script>
<style src="../../styles.css"></style>
